export const getStylesFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    
    return {
      // Colors
      primaryColor: params.get('primaryColor') || '#3b82f6',
      backgroundColor: params.get('backgroundColor') || '#ffffff',
      textColor: params.get('textColor') || '#000000',
      borderColor: params.get('borderColor') || '#e5e7eb',
      eventBackgroundColor: params.get('eventBgColor') || '#93c5fd',
      
      // Typography
      fontFamily: params.get('fontFamily') || 'system-ui',
      fontSize: params.get('fontSize') || '14px',
      headerFontSize: params.get('headerSize') || '24px',
      
      // Layout
      borderRadius: params.get('borderRadius') || '8px',
      padding: params.get('padding') || '16px',
      dayHeight: params.get('dayHeight') || '140px'
    };
  };